import "./App.css";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
} from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import Login from "./Pages/Login/Login";
import Register from "./Pages/Register/Register";
import ForgotPassword from "./Pages/ForgotPassword/ForgotPassword";
import PageNotFound from "./Pages/PageNotFound/PageNotFound";
import Test from "./Pages/Test";
// import ResetPassword from "./Pages/ResetPassword/ResetPassword";
import VerificationPage from "./Pages/VerificationPage/VerificationPage";
import PendingVerificationPage from "./Pages/PendingVerificationPage/PendingVerificationPage";
import RejectedVerification from "./Pages/RejectedVerification/RejectedVerification";
import { getAuth } from "firebase/auth";
import { AdminRoutes } from "./Routes/AdminRoutes";
import User from "./Layout/User/User";
import { StudentRoutes } from "./Routes/StudentRoutes";
import { ParentRoutes } from "./Routes/ParentRoutes";
import GetUser from "./Controllers/Users/GetUser";
import Loader from "./Components/Loader/Loader";
import { TeacherRoutes } from "./Routes/TeacherRoutes";
import { SuperAdminRoutes } from "./Routes/SuperAdminRoutes";
import { auth } from "./firebase";
// App
function App() {
  const [CurrentAuth, setCurrentAuth] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isUserSuperAdmin, setIsUserSuperAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = getAuth().onAuthStateChanged(async (user) => {
      const UserData = await GetUser(user?.uid);

      if (user) {
        user.getIdTokenResult().then((idTokenResult) => {
          if (idTokenResult.claims.admin) {
            setIsUserSuperAdmin(true);
          } else {
            setCurrentAuth(UserData);
          }
        });
      }

      setIsLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <Fragment>
      {isLoading ? (
        <Loader />
      ) : (
        <Router>
          <Routes>
            {isUserSuperAdmin === true ? (
              <Route path="/user" element={<User />}>
                {SuperAdminRoutes &&
                  SuperAdminRoutes.map((item, index) => {
                    return (
                      <Route
                        key={index}
                        path={item.path.split("/user/").pop()}
                        element={item.component}
                      />
                    );
                  })}
              </Route>
            ) : (
              <Route path="/user" element={<User />}>
                {CurrentAuth?.UserType === "admin"
                  ? AdminRoutes?.filter(
                      (routes) => routes.layout === "admin"
                    ).map((AdminRoute) => {
                      if (AdminRoute.children) {
                        return AdminRoute.children.map((subRoute) => {
                          return (
                            <Route
                              key="{user}"
                              path={subRoute.path.split("/user/").pop()}
                              element={subRoute.component}
                            />
                          );
                        });
                      } else {
                        return (
                          <Route
                            key="{user}"
                            path={AdminRoute.path.split("/user/").pop()}
                            element={AdminRoute.component}
                          />
                        );
                      }
                    })
                  : CurrentAuth?.UserType === "student"
                  ? StudentRoutes.filter(
                      (routes) => routes.layout === "student"
                    ).map((StudentRoute) => {
                      if (StudentRoute.children) {
                        return StudentRoute.children.map((subRoute) => {
                          return (
                            <Route
                              key="{user}"
                              path={subRoute.path.split("/user/").pop()}
                              element={subRoute.component}
                            />
                          );
                        });
                      } else {
                        return (
                          <Route
                            key="{user}"
                            path={StudentRoute.path.split("/user/").pop()}
                            element={StudentRoute.component}
                          />
                        );
                      }
                    })
                  : CurrentAuth?.UserType === "teacher"
                  ? TeacherRoutes.filter(
                      (routes) => routes.layout === "teacher"
                    ).map((TeacherRoute) => {
                      if (TeacherRoute.children) {
                        return TeacherRoute.children.map((subRoute) => {
                          return (
                            <Route
                              key="{user}"
                              path={subRoute.path.split("/user/").pop()}
                              element={subRoute.component}
                            />
                          );
                        });
                      } else {
                        return (
                          <Route
                            key="{user}"
                            path={TeacherRoute.path.split("/user/").pop()}
                            element={TeacherRoute.component}
                          />
                        );
                      }
                    })
                  : CurrentAuth?.UserType === "parent"
                  ? ParentRoutes.filter(
                      (routes) => routes.layout === "parent"
                    ).map((ParentRoute) => {
                      if (ParentRoute.children) {
                        return ParentRoute.children.map((subRoute) => {
                          return (
                            <Route
                              key="{user}"
                              path={subRoute.path.split("/user/").pop()}
                              element={subRoute.component}
                            />
                          );
                        });
                      } else {
                        return (
                          <Route
                            key="{user}"
                            path={ParentRoute.path.split("/user/").pop()}
                            element={ParentRoute.component}
                          />
                        );
                      }
                    })
                  : ""}
              </Route>
            )}

            <>
              {/* <Route path="/user" element={<User />}>
              {isUserSuperAdmin
                ? SuperAdminRoutes &&
                  SuperAdminRoutes.map((item) => {
                    console.log("super admin", item.path);
                    return (
                      <Route
                        key={"super admin"}
                        path={item.path.split("/user/").pop()}
                        element={item.component}
                      />
                    );
                  })
                : CurrentAuth?.UserType === "admin"
                ? AdminRoutes?.filter(
                    (routes) => routes.layout === "admin"
                  ).map((AdminRoute) => {
                    if (AdminRoute.children) {
                      return AdminRoute.children.map((subRoute) => {
                        return (
                          <Route
                            key="{user}"
                            path={subRoute.path.split("/user/").pop()}
                            element={subRoute.component}
                          />
                        );
                      });
                    } else {
                      return (
                        <Route
                          key="{user}"
                          path={AdminRoute.path.split("/user/").pop()}
                          element={AdminRoute.component}
                        />
                      );
                    }
                  })
                : CurrentAuth?.UserType === "student"
                ? StudentRoutes.filter(
                    (routes) => routes.layout === "student"
                  ).map((StudentRoute) => {
                    if (StudentRoute.children) {
                      return StudentRoute.children.map((subRoute) => {
                        return (
                          <Route
                            key="{user}"
                            path={subRoute.path.split("/user/").pop()}
                            element={subRoute.component}
                          />
                        );
                      });
                    } else {
                      return (
                        <Route
                          key="{user}"
                          path={StudentRoute.path.split("/user/").pop()}
                          element={StudentRoute.component}
                        />
                      );
                    }
                  })
                : CurrentAuth?.UserType === "teacher"
                ? TeacherRoutes.filter(
                    (routes) => routes.layout === "teacher"
                  ).map((TeacherRoute) => {
                    if (TeacherRoute.children) {
                      return TeacherRoute.children.map((subRoute) => {
                        return (
                          <Route
                            key="{user}"
                            path={subRoute.path.split("/user/").pop()}
                            element={subRoute.component}
                          />
                        );
                      });
                    } else {
                      return (
                        <Route
                          key="{user}"
                          path={TeacherRoute.path.split("/user/").pop()}
                          element={TeacherRoute.component}
                        />
                      );
                    }
                  })
                : CurrentAuth?.UserType === "parent"
                ? ParentRoutes.filter(
                    (routes) => routes.layout === "parent"
                  ).map((ParentRoute) => {
                    if (ParentRoute.children) {
                      return ParentRoute.children.map((subRoute) => {
                        return (
                          <Route
                            key="{user}"
                            path={subRoute.path.split("/user/").pop()}
                            element={subRoute.component}
                          />
                        );
                      });
                    } else {
                      return (
                        <Route
                          key="{user}"
                          path={ParentRoute.path.split("/user/").pop()}
                          element={ParentRoute.component}
                        />
                      );
                    }
                  })
                : ""}
            </Route> */}
            </>

            <Route path={"/forgot-password"} element={<ForgotPassword />} />
            <Route
              path={"/email-verification"}
              element={<VerificationPage />}
            />
            <Route
              path={"/verification-pending"}
              element={<PendingVerificationPage />}
            />
            <Route
              path={"/verification-rejected"}
              element={<RejectedVerification />}
            />

            <Route path={"/test"} element={<Test />} />
            <Route path={"*"} element={<PageNotFound />} />

            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />

            <Route path={"/register"} element={<Register />} />
          </Routes>
        </Router>
      )}
    </Fragment>
  );
}

export default App;
